/**
 * PageSkeleton — fallback genérico para Suspense de routes lazy.
 *
 * v8.5.48 · piel · marco — mismo esqueleto para todas las pantallas: barra
 * de título de 44px + tres bloques de 100px, todo en --line con el pulse
 * ya definido globalmente (.skel en index.css). Sin max-w propio: hereda
 * el max-w-[1280px] del <main> de Layout.jsx.
 */

export default function PageSkeleton() {
  return (
    <div className="space-y-5 animate-fadeIn">
      <div className="skel h-[44px] w-64" />
      <div className="skel h-[100px]" />
      <div className="skel h-[100px]" />
      <div className="skel h-[100px]" />
    </div>
  );
}
